/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';

import Header from '@components/Header';

import { getListDictionariesProcessLanguage } from '@actions/locale'

import { TypeProcess, LANGUAGE_DEFAULT } from '@constants/general'

class ProcessDictionary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: true,
      dictionaries: [],
      allDictionaries: [],
      dictionariesTotal: null,
      filterProcess: null,
      optionsProcess: [],
      filterTextDictionary: '',
      lazyParams: {
        first: 0,
        rows: 10,
        page: 0,
      }
    };
  }

  async componentDidMount() {
    await this.setOptionsProcess()
    await this.loadData();
  }
  
  setOptionsProcess = () => {
    const { t } = this.props
    const optionsProcess = [
      { label: t('Todos'), value: 'ALL' },
      { label: TypeProcess.PDD, value: TypeProcess.PDD },
      { label: TypeProcess.PRGEH, value: TypeProcess.PRGEH },
    ]

    this.onChange({target: { name: 'filterProcess', value: optionsProcess[0].value}})
    return this.setState({optionsProcess})
  }

  loadData = async () => {
    const { getListDictionariesProcessLanguage } = this.props;
    this.setState({ loadingTable: true });
    const response = await getListDictionariesProcessLanguage();
    if (!response?.status) {
      return this.setState({
        allDictionaries: response.data,
        dictionaries: response.data,
        dictionariesTotal: response.data.length,
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false });
  };

  searchData = () => {
    const { filterProcess, allDictionaries, filterTextDictionary } = this.state
    const { keysLenguages } = this.props
    let newdictionaries = []
    if (filterProcess === 'ALL') {
      newdictionaries =allDictionaries
    } else if (filterProcess ===  TypeProcess.PDD) {
      newdictionaries =  allDictionaries.filter(item => item.id_proceso === TypeProcess.PDD)
    } else if (filterProcess ===  TypeProcess.PRGEH) {
      newdictionaries =  allDictionaries.filter(item => item.id_proceso === TypeProcess.PRGEH)
    }

    if (filterTextDictionary && newdictionaries.length) {
      newdictionaries = newdictionaries.reduce((accum, item) => {
        let dictionaries = JSON.parse(item.diccionario)
        dictionaries = Object.keys(dictionaries).reduce((accum, item) => { // Se obtienen solo los diccionarios de los idiomas actuales
          if (keysLenguages.indexOf(item) > -1) accum[item] = dictionaries[item]
          return accum
        }, {})
        const isExist =Object.keys(dictionaries).reduce((validate, language) => {
           Object.keys(dictionaries[language]).map(key => {
             if ((key.toUpperCase()).includes(filterTextDictionary.toUpperCase())) validate = true
             else if ((dictionaries[language][key].toUpperCase()).includes(filterTextDictionary.toUpperCase())) validate = true
             return true
           })
           return validate
        }, false)
        if (isExist) accum.push(item)
        return accum
      }, [])
    }
    this.setState({
      dictionaries: newdictionaries,
      dictionariesTotal: newdictionaries.length,
      lazyParams: {
        first: 0,
        rows: 10,
        page: 0,
      }
    })

  }

  loadDataByPage = () => {
    const { lazyParams, allDictionaries } = this.state
    const dataPage = allDictionaries.slice(lazyParams.first, (lazyParams.first + lazyParams.rows))
    this.setState({ dictionaries: dataPage })
  }

  onPage = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    this.setState({ lazyParams: _lazyParams }, this.loadDataByPage);
  };

  onChange = ({target}) => {
    this.setState({[target.name]: target.value});
  };

  columnDictionary = (node, detail) => {
    const { history } = this.props
    const { filterTextDictionary } = this.state
    return (
      <div>
        <span className="p-column-title">{detail.header}</span>
        <Button
          type="button"
          icon="pi pi-book"
          className="p-button-text"
          style={{ marginRight: '.5em' }}
          onClick={() => history.push({pathname:'/process-dictionary/traslate', state: { path: node.url, textSearch: filterTextDictionary }})}
        />
      </div>
    )
  };

  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  templateEstatus = (node, detail) => {
    const { t } = this.props
    if (node.activo) {
      return (
        <div className="p-text-center-lg">
          <span className="p-column-title">{detail.header}</span>
          <i className="pi pi-check" />
        </div>
      );
    }
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-red cursor-not-pointer" aria-hidden="true" > {t('OCULTA')} </span>
        </>
      );
  }

  render() {
    const { history, t } = this.props;
    const { loadingTable, dictionaries, lazyParams, dictionariesTotal, filterProcess, optionsProcess, filterTextDictionary } = this.state;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
      </>
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Diccionario de procesos')} rightComponent={rightHeader} />
          <div className="card p-grid">
            <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
              <label className="p-mr-2 p-text-bold">{t('Tipo de proceso')}:</label>
              <Dropdown
                name="filterProcess"
                value={filterProcess}
                options={optionsProcess}
                onChange={this.onChange}
                optionLabel="label"
                // showClear
                filterBy="label"
                placeholder=""
                style={{ width: '70%' }}
              />
            </div>
            <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
              <label className="p-mr-2 p-text-bold">{t('Texto en diccionarios')}:</label>
              <InputText
                name="filterTextDictionary"
                value={filterTextDictionary}
                onChange={this.onChange}
              />
            </div>
            <div className="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
              <Button
                icon="pi pi-search"
                label={t('Buscar')}
                className="p-button-raised p-button-text p-button-plain btn-search-list"
                onClick={() => this.searchData()}
              />
            </div>
            <div className="p-col-12 p-mt-2">
              <DataTable
                value={dictionaries}
                lazy
                loading={loadingTable}
                className="table-languages"
                paginator={!!dictionariesTotal}
                rows={lazyParams.rows}
                totalRecords={dictionariesTotal}
                first={lazyParams.first}
                page={lazyParams.page}
                onPage={this.onPage}
              >
                <Column
                  header={t('URL')}
                  field="url"
                  body={this.columnResponsive}
                />
                <Column
                  header={t('Titulo')}
                  field="titulo"
                  body={this.columnResponsive}
                />
                <Column
                  header={t('Tipo proceso')}
                  field="id_proceso"
                  body={this.columnResponsive}
                  // className="column-max p-text-center-lg"
                />
                <Column
                  header={t('Diccionario')}
                  body={this.columnDictionary}
                  className="column-max p-text-center-lg"
                />
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  keysLenguages: state.catalogs.keysLanguageCatalog,
});

const mapDispatchToProps = {
  getListDictionariesProcessLanguage
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(ProcessDictionary);
